import ComputingMetrics from '@/components/computingMetrics/ComputingMetrics';
import ComputingMetricsList from '@/components/computingMetrics/ComputingMetricsList';
import ComputingMetricsForm from '@/components/computingMetrics/ComputingMetricsForm';

export default {
    path: '/computingMetrics',
    component: ComputingMetrics,
    children: [
        {
            path: '/',
            name: 'ComputingMetrics',
            component: ComputingMetricsList
        },
        {
            path: 'new',
            name: 'ComputingMetricsNew',
            component: ComputingMetricsForm
        },
        {
            path: 'edit/:computingMetricId',
            name: 'ComputingMetricsEdit',
            component: ComputingMetricsForm
        }
    ],
    meta: {requiresAuth: true}
}